import React from 'react'
import { Helmet } from 'react-helmet'

function SEO(props) {
  let { description, title, url, service, breadcrumbs, fullSchema } = props

  service = service || 'Home HealthCare'

  const noindex = false

  if (!description) {
    description = 'Portea Home Health Care'
  }

  if (!title) {
    title = 'Portea Home Health Care'
  }

  url = `https://www.portea.com${url}`

  const author =
    'Dr. Udaya Kumar Maiya (MBBS, MD, DNB(RT), DCCF (Paris), Medical Director, Portea'
  const company = 'Portea Medical'

  const schemaOrgWebPage = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    url: 'https://www.portea.com',
    headline: 'Healthcare at Homme - Home Medical Care',
    inLanguage: 'en',
    mainEntityOfPage: 'https://www.portea.com',
    description: 'Healthcare at Homme - Home Medical Care',
    name: 'Healthcare at Homme - Home Medical Care',
    author: {
      '@type': 'Person',
      name: author,
    },
    copyrightHolder: {
      '@type': 'Organization',
      name: company,
    },
    copyrightYear: '2019',
    creator: {
      '@type': 'Organization',
      name: company,
    },
    publisher: {
      '@type': 'Organization',
      name: company,
    },
  }

  const schemaArticle = {
    '@context': 'http://schema.org',
    '@type': 'Article',
    author: {
      '@type': 'Person',
      name: author,
    },
    copyrightHolder: {
      '@type': 'Organization',
      name: company,
    },
    copyrightYear: '2019',
    creator: {
      '@type': 'Organization',
      name: company,
    },
    description,
    headline: title,
    inLanguage: 'en',
    url,
    name: title,
    mainEntityOfPage: url,
  }

  const personSchema = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    honorificPrefix: 'Dr.',
    honorificSuffix: '(MBBS, MD, DNB(RT), DCCF (Paris)',
    jobTitle: 'Medical Director',
    name: 'M. Udaya Kumar Maiya',
    url: 'https://www.portea.com',
    sameAs: ['https://in.linkedin.com/in/dr-udaya-kumar-maiya-73202a5'],
    memberOf: {
      '@type': 'Organization',
      name: company,
    },
  }

  const itemListElement = breadcrumbs.map(({ target, display }, i) => ({
    '@type': 'ListItem',
    item: {
      '@id': `https://www.portea.com${target}`,
      name: display,
    },
    position: i,
  }))

  const breadcrumb = {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    description: 'Breadcrumbs list',
    name: 'Breadcrumbs',
    itemListElement,
  }


  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      {noindex && <meta name="ROBOTS" content="NOINDEX, NOFOLLOW" />}

      {fullSchema && (<script type="application/ld+json">{JSON.stringify(fullSchema)}</script>)}

      {service && (
        <script type="application/ld+json">
          {JSON.stringify(schemaOrgWebPage)}
        </script>
      )}
      {service && (
        <script type="application/ld+json">
          {JSON.stringify(personSchema)}
        </script>
      )}
      {service && (
        <script type="application/ld+json">
          {JSON.stringify(schemaArticle)}
        </script>
      )}
      <script type="application/ld+json">{JSON.stringify(breadcrumb)}</script>
    </Helmet>
  )
}

export default SEO
